<template>
  <div>
    <div class="l-block__infoarea">
      <img src="@/assets/img/ico-information.svg" alt="" />
      「検索順位チェック」に追加したコンテンツが表示されます。
    </div>
    <div class="l-block__content u-pt20">
      <Loading v-if="isLoadingExistingContentsTerm" />
      <template v-if="!isLoadingExistingContentsTerm">
        <div class="l-block__graphArea--left">
          <TitleSub level="h4">
            <span class="title">順位ごとのコンテンツ数と割合</span>
            <Tooltip size="sm">
              過去30日間の平均順位・クリック率をもとに集計しています。<br />
              なおクリック率は以下の基準で判定しています。 <br />
              獲得順位1~1.9位: 15%<br />
              獲得順位2~2.9位: 10% <br />
              獲得順位3~3.9位: 6% <br />
              獲得順位4~4.9位: 4%<br />
              獲得順位5~5.9位: 3%<br /><br />
              ※検索順位チェックにご登録後、データの反映には3日程度かかる場合があります。
            </Tooltip>
          </TitleSub>
          <GraphSummaryChart
            :data="existingContentsSummary"
            :isLoading="isLoadingExistingContentsSummary"
          />

          <ul class="c-graph-legend">
            <li class="c-graph-legend__item c-graph-legend__item--ctrHigh">
              <span class="c-graph--guide">1~5位(クリック率が高い)</span>
              <span
                >：{{ existingContentsSummary.ctrHigh.contentsCount }}件</span
              >
            </li>
            <li class="c-graph-legend__item c-graph-legend__item--ctrLow">
              <span class="c-graph--guide">1~5位(クリック率が低い)</span>
              <span
                >：{{ existingContentsSummary.ctrLow.contentsCount }}件</span
              >
            </li>
            <li class="c-graph-legend__item c-graph-legend__item--rankMiddle">
              <span class="c-graph--guide">6~50位</span>
              <span
                >：{{
                  existingContentsSummary.rankMiddle.contentsCount
                }}件</span
              >
            </li>
            <li class="c-graph-legend__item c-graph-legend__item--rankLow">
              <span class="c-graph--guide">51位以下(データなしを含む)</span>
              <span
                >：{{ existingContentsSummary.rankLow.contentsCount }}件</span
              >
            </li>
          </ul>
        </div>

        <div class="l-block__graphArea--right">
          <div class="l-block__graphArea__title">
            <h4 class="c-title c-title--h04">順位ごとの割合の推移</h4>

            <ul class="c-graph-legend">
              <li class="c-graph-legend__item c-graph-legend__item--ctrHigh">
                1~5位(クリック率が高い)
              </li>
              <li class="c-graph-legend__item c-graph-legend__item--ctrLow">
                1~5位(クリック率が低い)
              </li>
              <li class="c-graph-legend__item c-graph-legend__item--rankMiddle">
                6~50位
              </li>
              <li class="c-graph-legend__item">51位以下(データなしを含む)</li>
            </ul>
          </div>

          <GraphTerm
            :data="existingContentsTerm"
            :period="term.period"
            :isLoading="isLoadingExistingContentsTerm"
          />

          <p class="c-graph c-graph--description">
            最新月は4日目からデータが表示されます
          </p>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Loading from '@/components/Loading';
import TitleSub from '@/components/TitleSub';
import Tooltip from '@/components/Tooltip';
import GraphTerm from '@/components/dashboard/GraphTerm';
import GraphSummaryChart from '@/components/dashboard/GraphSummaryChart';

import utils from '@/utils';

export default {
  props: {
    project: {
      type: Object,
      required: true
    },
    existingContentsSummary: {
      type: Object,
      required: true
    },
    existingContentsTerm: {
      type: Array,
      required: true
    },
    isLoadingExistingContentsSummary: {
      type: Boolean,
      required: true
    },
    isLoadingExistingContentsTerm: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      summary: {
        data: {
          items: []
        },
        list: {
          items: [],
          isEdited: false,
          isLoading: true
        },
        period: [],
        isLoading: true
      },
      term: {
        data: {
          items: []
        },
        list: {
          items: [],
          isEdited: false,
          isLoading: true
        },
        period: [],
        isLoading: true
      }
    };
  },

  created() {
    // 環境がdemoの場合はデモ用の表示期間で固定するようにする
    // 表示期間で固定：local, prototypeを一旦追加
    if (
      process.env.VUE_APP_ENV === 'demo' ||
      process.env.VUE_APP_ENV === 'local' ||
      process.env.VUE_APP_ENV === 'prototype'
    ) {
      // GSCのデモ用の期間を仕様
      let to = utils.getGADemoPeriod('all')[1];
      to = utils.getStartDate(to, 'month');
      let from = utils.getDateResetHours(to);
      from.setFullYear(from.getFullYear() - 1);
      from.setMonth(from.getMonth() + 1);
      this.term.period = [from, to];
    } else {
      let to = utils.getDateResetHours();
      to.setDate(to.getDate() - 1);
      to = utils.getStartDate(to, 'month');
      let from = utils.getDateResetHours(to);
      from.setFullYear(from.getFullYear() - 1);
      from.setMonth(from.getMonth() + 1);
      this.term.period = [from, to];
    }
  },

  components: {
    Loading,
    TitleSub,
    Tooltip,
    GraphTerm,
    GraphSummaryChart
  }
};
</script>
